(ns quuppa.qsm.configuration.view
  (:require [re-frame.core :as rf]
            ["react" :as react]
            [quuppa.peweb.query :as q]
            [quuppa.ui.spinner :refer [spinner]]
            [quuppa.ui.layout :as layout]
            [quuppa.routing :as routing]
            [quuppa.peweb.peinfo-jvm-params :refer [jvm-parameters-panel]]
            [quuppa.qsm.release.view :as release]
            [quuppa.qsm.metadata.view :as metadata]
            [quuppa.qsm.configuration.subs :as s]
            [quuppa.qsm.configuration.events :as e]
            [quuppa.qsm.boot-command.view :as boot-command-view]
            [quuppa.qsm.boot-command.events :as boot-command-events]))

(def feature-unsupported-message
  [:p "This QPE is running an older version that doesn't support this feature. Please update to the latest version."])

(def connection-options
  [{:id    :continuously
    :value true
    :label "Continuously"}
   ; {:id            :interval
   ;  :label         "At intervals of "
   ;  :default-value 1}
   ; {:id    :api
   ;  :label "For any location API request"}
   ; {:id    :active
   ;  :label "When actively monitoring this QPE"}
   ; {:id    :tag-table
   ;  :label "When on the tag table"}
   ; {:id    :active-cs
   ;  :label "For active coordinate system in map view"}
   {:id    :never
    :value false
    :label "Never"}])

(defn qpe-position-events [{:keys [qpe-subscribe qpe-dispatch]}]
  (let [position-events-value @(qpe-subscribe [::s/value :enable-position-events])
        feature-supported  @(qpe-subscribe [:qsm/qpe-feature-supported :qpe-options/enable-position-events])]
    [:tr
     [:th {:scope "col"}
      "Receive location updates"

      (when-not feature-supported
        feature-unsupported-message)]

     [:td
      [:ul.px-0.my-0
       {:style {:list-style "none"}}
       (for [{:keys [id value label]} connection-options]
         [:li
          {:key id}
          [:label
           [:input.mr-4
            {:type      "radio"
             :checked   (= position-events-value value)
             :on-change (fn [_e]
                          (qpe-dispatch [::e/set-values {:enable-position-events value}]))
             :disabled (not feature-supported)}]
           label]])]]

     [:td
      [:p.m-0 "Control how often this Engine will forward location updates to QSM."]]]))

(defn location-based-commands [{:keys [qpe-subscribe qpe-dispatch] :as _opts}]
  (let [current-project @(qpe-subscribe [:current-project/info])]
    ;; TODO: Is this value saved by PE-lib somewhere?
    ;; NO -> Todo: should this be saved?
    ;; this is also still present on peinfo/peinfo-software component
    [:tr
     [:th.border-0 {:scope "col"} "Location based commands"]
     [:td.border-0
      (when (:activation-status current-project)
        (case (:activation-status current-project)
          :not-available [:span "-"]
          :not-configured [:span "Not configured"]
          [:div.btn-group
           [:button.btn.btn-outline-primary.btn-sm
            {:on-click #(qpe-dispatch [:qpe/enable-location-based-commands :enabled])
             :class (when (= :enabled (:activation-status current-project)) "active")}
            "Enabled"]
           [:button.btn.btn-outline-primary.btn-sm
            {:on-click #(qpe-dispatch [:qpe/enable-location-based-commands :disabled])
             :class (when (= :disabled (:activation-status current-project)) "active")}
            "Disabled"]]))]
     [:td.border-0
      [:p
       "Status of Location Based Commands in the Project."]
      [:p
       "The LBS commands may be disabled e.g. when no interesting
       activity is happening on sport event. This may improve
       the Tag battery lifetime considerably."]
      [:p.m-0
       ;; TODO: Should be store the option on QPE-next node?
       "This option is lost when Engine is restarted."]]]))

(def direct-qpe-access-info
  "If disabled (OFF), users can access the QPE only via the Site Manager.
   The QPE APIs will also be accessible only via the APIs exposed by the Site Manager")

(defn direct-access-to-qpe-api
  [{:keys [qpe-dispatch qpe-subscribe]} disabled?]
  (let [locked? @(qpe-subscribe [::s/value :locked])
        feature-supported @(qpe-subscribe [:qsm/qpe-feature-supported :qpe-options/lock])]
    [:tr
     [:th.w-25
      {:scope "col"}
      "Direct access to QPE"

      (when-not feature-supported
        feature-unsupported-message)]

     [:td.w-25
      [:div.btn-group
       [:button.btn.btn-outline-primary
        {:class (if locked? "" "active")
         :disabled (or disabled? (not feature-supported))
         :on-click #(qpe-dispatch [::e/set-values {:locked false}])}
        "ON"]
       [:button.btn.btn-outline-primary
        {:class (if locked? "active" "")
         :disabled (or disabled? (not feature-supported))
         :on-click #(qpe-dispatch [::e/set-values {:locked true}])}
        "OFF"]]]

     [:td
      [:p.m-0 direct-qpe-access-info]]]))

(defn proxy-configuration-lock-control-panel
  [{:keys [qpe-dispatch qpe-subscribe]} disabled?]
  (let [locked? @(qpe-subscribe [::s/value :proxy-configuration-ui-access-lock])]
    [:tr
     [:th.w-25
      {:scope "col"}
      "Direct access to proxy configuration page"]

     [:td.w-25
      [:div.btn-group
       [:button.btn.btn-outline-primary
        {:class (if locked? "" "active")
         :on-click #(qpe-dispatch [::e/set-values {::proxy-configuration-ui-access-lock false}])}
        "ON"]
       [:button.btn.btn-outline-primary
        {:class (if locked? "active" "")
         :on-click #(qpe-dispatch [::e/set-values {::proxy-configuration-ui-access-lock true}])}
        "OFF"]]]

     [:td
      [:p.m-0 direct-qpe-access-info]]]))

(defn jvm-parameters
  [{:keys [qpe-dispatch]}]
  [:tr
   [:th.w-25
    {:scope "col"}
    "Startup options"]

   [:td.w-25
    [:button.btn.btn-primary
     {:on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar] {:type :jvm-parameters}])}
     "Open options"]]

   [:td
    [:p.m-0 "The JVM startup options can control both the JVM and the Engine."]]])

(defn jvm-parameters-sidebar [qpe
                              {:keys [qpe-dispatch] :as opts}
                              {:keys [container-ref show]}]
  [layout/sidepanel
   {:show show
    :class "sidebar-lg"
    :on-hide #(qpe-dispatch [:qpe/close-sidebar])
    :container container-ref}
   [layout/sidebar-header
    {:on-close #(qpe-dispatch [:qpe/close-sidebar])
     :title "Startup options"}]

   [layout/sidebar-content
    (if (= "offline" (:status qpe))
      [:p "QPE is offline."]
      [:f> jvm-parameters-panel
       opts
       {:container-ref container-ref}])]])

(defn configuration-content [{:keys [qpe opts owner-or-admin?]}]
  (let [status (:status qpe)
        offline?     (= "offline" status)
        qpe-identity (:identity qpe)]
    (q/use-query boot-command-events/boot-commands-query {:qpe_identity qpe-identity})
    (react/useEffect (fn []
                       ;; Load available release channels for upgrade functionality
                       (rf/dispatch [:qsm/get-available-release-channels]))
                     #js [])
    (react/useEffect (fn []
                       ;; fetch previous installations to app-db
                       (rf/dispatch [:qsm/fetch-previous-installations qpe-identity]))
                     #js [qpe-identity])
    (routing/use-subscriptions
      [[:qpe/event {:qpe-identity qpe-identity :event [:release/download-status]}]
       [:qpe-boot/command-registered {:qpe_identity qpe-identity}]
       [:qpe-boot/command-removed {:qpe_identity qpe-identity}]]
      #js [qpe-identity])
    [:<>
     [:div.mb-3.d-flex.flex-row.flex-nowrap.row.gx-3
      [:div.col-6
       [metadata/view qpe opts]]]

     ;; rendering release update section doesn't make sense if we don't have version information already
     [:div.mb-3.d-flex.flex-row.flex-nowrap.row.gx-3
      [:div.col-6
       (if (:version qpe)
         [:f> release/qpe-releases-panel qpe opts]
         [spinner])]

      (when owner-or-admin?
        [:div.col-6
         [boot-command-view/view qpe opts]])]

     (when owner-or-admin?
       [:div.mb-3.d-flex.flex-row.flex-nowrap.row.gx-3
        [:div.col-12
         [:div.card.bg-gray-30.p-2.pl-3.flex-shrink-1
          [:div.d-flex.align-items-center.mb-1
           [:h5.py-2.my-0.flex-grow-1 "Options"]]

          [:table.table.my-0.align-middle
           [:thead]
           [:tbody
            [jvm-parameters opts]
            [direct-access-to-qpe-api opts offline?]
            ;[proxy-configuration-lock-control-panel opts offline?]
            [qpe-position-events opts]
            ;; NOTE: Border-0 added to cells on the last row, adjust if new row added to the end.
            [location-based-commands opts]]]]]])]))

(defn configuration-view
  "This is currently used by both Engines view and Site view."
  [{:keys [qpe opts header owner-or-admin?]}]
  (let [qpe-subscribe (:qpe-subscribe opts)
        sidebar-type @(qpe-subscribe [:qpe/data :ui :sidebar :type])
        layout-ref   (react/useRef)]
    [layout/section
     {:ref   layout-ref
      :id    "configuration-view"
      :class "position-relative"}
     [layout/view-content
      {:sidebar-open sidebar-type}

      (or header
          [layout/view-header
           {:title "Engine configuration"}])

      [:f> configuration-content
       {:qpe qpe
        :opts opts
        :owner-or-admin? owner-or-admin?}]]

     (case sidebar-type
       :metadata [metadata/metadata-sidebar qpe opts owner-or-admin?]
       nil)

     [jvm-parameters-sidebar
      qpe opts
      {:show (= :jvm-parameters sidebar-type)
       :container-ref layout-ref}]

     [:f> release/available-releases-sidebar
      qpe opts
      {:show (= :available-releases sidebar-type)
       :container-ref layout-ref}]]))
